module.exports = __webpack_public_path__ + "images/337bdaf85b4e729b955606fa25a65c18.png";